// extracted by mini-css-extract-plugin
export default {"editButton":"hrRelease_editButton__Olkjd","TableBody":"hrRelease_TableBody__E+Yb1","StopButton":"hrRelease_StopButton__nDBv7"};